import * as React from "react";
import { SVGProps } from "react";

export const IconZoomMeeting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={17} height={16.5} rx={3} fill="#1976D2" />
    <path
      d="M3.5 5.775V9.46a1.51 1.51 0 001.516 1.5h5.38a.274.274 0 00.275-.272V7.003a1.509 1.509 0 00-1.516-1.5H3.776a.274.274 0 00-.276.272zm7.514 1.437l2.22-1.62c.193-.159.343-.119.343.17V10.7c0 .328-.183.288-.343.169l-2.22-1.616V7.212z"
      fill="#fff"
    />
  </svg>
);
